import React from 'react';
import {FaTwitter, FaDiscord, FaGlobe} from 'react-icons/fa';

export const Footer = () => {
  return (
    <div style={{ marginTop: '100px', color: 'white' }}>
      <div className='container'>
        <div className='row' style={{ rowGap: '20px' }}>
          <div className='col-sm-12 col-lg-6 footer-align'>
            <div>
              <h5 className='mb-4'>Follow us:</h5>
              <div className='d-flex gap-4 footer-align'>
                <a className='social-box' href="https://twitter.com/JewelSwapX" target="_blank" rel="noreferrer">
                  <FaTwitter />
                </a>
                <a className='social-box' href="https://discord.gg/eAaP32ncCb" target="_blank" rel="noreferrer">
                  <FaDiscord />
                </a>

                <a className='social-box' href="https://jewelswap.io" target="_blank" rel="noreferrer">
                  <FaGlobe />
                </a>
              </div>
            </div>
          </div>
          {/* <div className='col-sm-12 col-lg-6 d-flex justify-content-center align-items-center'>
            <div className=''>
              <div className='footer-feature'>Lend EGLD</div>
              <div className='footer-feature mt-2'>Borrow EGLD</div>
              <div className='footer-feature mt-2'>Down Payment Buy</div>
              <div className='footer-feature mt-2'>My Loans</div>
            </div>
          </div> */}

          <div className='col-sm-12 mt-2 footer-align'>
            <p>
              Powered By {' '}
              <a href="https://twitter.com/ElrondPunks" className="egns-lab" target="_blank" rel="noreferrer">
                Epunks
              </a> & <a href="https://www.combased.io/" className="egns-lab" target="_blank" rel="noreferrer">
                Combased
              </a>
            </p>
          </div>
        </div>
      </div>
    </div >
  );
};
